import type { EquippedItem } from 'app/frontend/types/custom'
import type { ItemEquipmentSlot } from 'app/frontend/types/custom/ItemSlot'
import type { SeasonVoidforged } from 'app/frontend/types/custom/Season'

export const voidforgedStatus = (
  gear: Partial<Record<string, EquippedItem>> | undefined,
  voidforged: SeasonVoidforged,
) => {
  const twoHanded = !!gear?.main_hand?.id && !gear?.off_hand?.id
  const slots: ItemEquipmentSlot[] = [
    'neck',
    'trinket_1',
    'trinket_2',
    'main_hand',
    ...(twoHanded ? [] : (['off_hand'] as const)),
  ]
  const bonusIds = [
    ...Object.values(voidforged.bonus_ids),
    voidforged.crafted_bonus_id,
  ].filter((id): id is number => id != null)

  const items: { slot: ItemEquipmentSlot; item: EquippedItem }[] = []
  let required = slots.length

  slots.forEach((slot) => {
    const item = gear?.[slot]
    if (!item?.id) return

    if ((item.bonus_ids ?? []).some((id) => bonusIds.includes(id))) {
      items.push({ slot, item })
    } else if (item.ilvl >= voidforged.item_levels.mythic) {
      required -= 1
    }
  })

  return { items, count: items.length, required }
}

export const voidforgedStatusClass = ({
  count,
  required,
}: {
  count: number
  required: number
}) =>
  required > 0 && count === 0
    ? 'text-destructive-foreground'
    : count < required
    ? 'text-warning-foreground'
    : 'text-success-foreground'
